//!!import React from "react";
import PropTypes from "prop-types";
//!!import clsx from "clsx";

//!!import { Row, Col } from "react-bootstrap";
//!!import PageSection from "components/PageSection";
//!!import Partner from "components/Partner";

const Partners = ({ className, frontmatter }) => {
  if (!frontmatter) {
    return null;
  }

  const { anchor, partners } = frontmatter;

  return null;
/*!!
  return (
    <PageSection className={clsx("py-5", className)} id={anchor}>
      <Row>
        {partners.map(({ href, imageFileName }) => (
          <Col md={3} sm={6} className="my-3" key={imageFileName}>
            <Partner href={href} imageFileName={imageFileName} />
          </Col>
        ))}
      </Row>
    </PageSection>
  );
!!*/
};

Partners.propTypes = {
  className: PropTypes.string,
  frontmatter: PropTypes.object,
};

Partners.defaultProps = {
  className: null,
  frontmatter: null,
};

export default Partners;
